export enum Role {
    Admin = 'Admin',
    Basic = 'Basic'
  }
  